import { AppButtonProps, useAppButtonState } from "../../AppButton/next";

import { useButton_unstable } from "@fluentui/react-button";

export const useAppSplitButtonPrimaryButton = (
  props: AppButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { disabled } = props;

  // Remove ID so it doesn't get added as an attribute on the HTML button
  const { id, ...propsWithoutId } = props;
  // 'type' override here needed so that our types (e.g. "AppButtonProps") aren't assigned to the HTML element
  const state = useButton_unstable(
    { ...propsWithoutId, type: "button", disabledFocusable: disabled },
    ref
  );

  return useAppButtonState(props, state);
};
